import { reactive } from "vue";

interface SidebarStore {
    open: boolean;
    onChange: () => void;
}
const sidebarSrore: SidebarStore = reactive({
    open: false,
    onChange ()  {
        sidebarSrore.open = !sidebarSrore.open
      },
});

export default sidebarSrore;